import dotProp from "dot-prop";

/**
 * Converts a value or an array of values to the property of that value or values.
 *
 * @param value - Value or array of values to convert.
 * @param key - Property of the value you want to convert to.
 */
export const convertToKey = (value: any | any[], from: string, to: string): any | any[] => {
	if (!value) {
		return;
	}

	if (!Array.isArray(value)) {
		return {
			...value,
			[from]: dotProp.get(value, to),
		};
	}

	return value.map((val) => {
		return {
			...val,
			[from]: dotProp.get(val, to),
		};
	});
};
